module.exports = __webpack_public_path__ + "img/horizontal_6_1_7005.5f9d5a28.png";